import { SVGProps } from "react";

export function Buy({ className }: SVGProps<SVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.22266 3.94482H10.8898L10.4083 10.4452H2.70416L2.22266 3.94482Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.5"
        strokeLinejoin="round"
      />
      <path
        d="M4.63019 4.90763V1.77783H8.48225V4.90763"
        stroke="currentColor"
        strokeWidth="0.963015"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.63019 8.51904H8.48225"
        stroke="white"
        strokeWidth="0.963015"
        strokeLinecap="round"
      />
    </svg>
  );
}
